import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

import redemption from '../../assets/icons/redemption-icon.svg'

/* import CardProdutosCarritos from '../Carrito/cardProductosCarrito'  */
import * as constant from '../../global/const';
import CartProducto from './CartProducto';
import { useCounter } from '../../Helpers/useCounter';
import { Reposition } from './Reposicion/Reposition.component';
import { ModalNotificacionNovedad } from './Modales/modalNotificacionNovedad.component';

const Steep1 = ({ history }) => {

    const carritoRedux = useSelector(state => state.carrito.carrito);
    //let _carritoPromos = JSON.parse(localStorage.getItem(constant.CARRITOPROMO)) || {};
    let carritoPromosRedux = useSelector(state => state.carritoPromo.carritoPromos);
    let _notificaciones = JSON.parse(localStorage.getItem('notificaciones')) || [];

    const [productos, setProductos] = useState(true);
    const [reposicion, setReposicion] = useState(false);
    const [packages, setPackages] = useState(false);

    const [open, setOpen] = useState(false);
    const [close, setclose] = useState(true);
    const [showModal, setShowModal] = useState(_notificaciones.length ? true : false);

    let redenciones = Object.keys(carritoPromosRedux);


    // const sucursal = useSelector(state => state.page.sucursal);
    let _carrito = JSON.parse(localStorage.getItem(constant.CARRITO)) || {}

    const {counter, totalAmount, iva, ico, ibua, icui} = useCounter();

    const handleMenu = (opcion) => {
        if (opcion == 0) {
            setProductos(true);
            setReposicion(false);
            setPackages(false);
        } else if (opcion == 1) {
            setProductos(false);
            setReposicion(true);
            setPackages(false);
        } else if (opcion == 2) {
            setProductos(false);
            setReposicion(false);
            setPackages(true);
        }
    }

    useEffect(()=>{

    },[redenciones, _carrito, productos])

    return (
        <div className="content-steeps">
            <div className="steeps">
                <div className="steep-circle">1</div>
                <div className="description">
                    <b>Primer paso</b>: revisa los productos seleccionados y si tienes obsequios o elementos a seleccionar.
                </div>
            </div>
            {/*<div className="reposition">
                <button
                    className={(productos ? "reposition-selected" : "") + " reposition-products"}
                    onClick={() => handleMenu(0)}
                >
                    Productos
                    <div
                        className="aux-tool"
                    ></div>
                </button>
                <button
                    className={(reposicion ? "reposition-selected" : "") + " reposition-replacement"}
                    onClick={() => handleMenu(1)}
                >
                    Obsequios
                    <img
                        src={redemption}
                        alt="Not Found"
                        style={
                            {
                                display: Object.keys(_carritoPromos).length > 0 ? 'block' : 'none'
                            }
                        }
                    >
                    </img>
                    <div className="aux-tool"></div>
                </button>
                <button
                    className={(packages ? "reposition-selected" : "") + " reposition-packages"}
                    onClick={() => handleMenu(2)}
                >
                    Envases
                    <div className="aux-tool"></div>
                </button> 
            </div>*/}
            <div className={"content-carrito scrollSlider " + (carritoRedux ? (Object.keys(carritoRedux).length > 3 ? " aux" : "") : "")}>
                {
                    productos
                        ?
                        carritoRedux
                        &&
                        Object.keys(carritoRedux)
                            .map(
                                (codigoSku) =>
                                    <CartProducto history={history} producto={carritoRedux[codigoSku]}></CartProducto>
                            )
                        :
                        reposicion
                            ?
                            //Aca debo recticar si embiar el redux o el original
                            <Reposition carrito={carritoRedux} history={history} />
                            :
                            <h2>Envases</h2>
                }
                {
                    <Reposition carrito={carritoRedux} history={history} />
                }
            </div>
            {
                showModal
                &&
                <ModalNotificacionNovedad novedades={_notificaciones} setShowModal={setShowModal} />
            }
        </div >
    )

}

export default Steep1